import PrimaryButton from "components/buttons/primary-button";
import Logo from "components/logo";
import Modal from "components/modal";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import ShareModal from "../share-modal";
import Typography from "components/typography";
import { useClickOutside } from "hooks/UseClickOutside";

interface IProps {}
const Navbar = ({}: IProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  const optionRef = useRef(null);

  useClickOutside(optionRef, () => {
    setIsOptionsOpen(false);
  });
  return (
    <Container>
      <Logo width="8rem" />
      <Buttons>
        <PrimaryButton
          onClick={() => setIsModalOpen(true)}
          text="Share"
          variant="p-fade"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M18.3327 11.665C18.3086 14.51 18.1506 16.0784 17.1163 17.1127C15.8956 18.3334 13.9309 18.3334 10.0015 18.3334C6.07212 18.3334 4.10743 18.3334 2.88672 17.1127C1.66602 15.892 1.66602 13.9273 1.66602 9.99791C1.66602 6.06851 1.66602 4.10381 2.88672 2.88311C3.92101 1.84881 5.48941 1.69087 8.33443 1.66675"
                stroke="#FEA101"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M18.3333 5.83341H11.6667C10.152 5.83341 9.23892 6.57676 8.90033 6.91699C8.7955 7.02236 8.74308 7.07505 8.74233 7.07576C8.74167 7.07648 8.68892 7.12891 8.58358 7.23376C8.24335 7.57234 7.5 8.48541 7.5 10.0001V12.5001M18.3333 5.83341L14.1667 1.66675M18.3333 5.83341L14.1667 10.0001"
                stroke="#FEA101"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          iconPosition="right"
          iconSize="2"
        />
        <PrimaryButton
          text="Customize"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M11.6521 4.45507L12.3008 3.80625C13.3758 2.73125 15.1188 2.73125 16.1938 3.80625C17.2688 4.88124 17.2688 6.62415 16.1938 7.69915L15.5449 8.34796M11.6521 4.45507C11.6521 4.45507 11.7331 5.8338 12.9497 7.05033C14.1662 8.26686 15.5449 8.34796 15.5449 8.34796M11.6521 4.45507L5.68718 10.4199C5.28316 10.824 5.08116 11.0259 4.90743 11.2487C4.70249 11.5115 4.5268 11.7957 4.38344 12.0965C4.26191 12.3515 4.17158 12.6226 3.99089 13.1646L3.22527 15.4615M15.5449 8.34796L9.58008 14.3129C9.17604 14.7168 8.97409 14.9188 8.75135 15.0926C8.48858 15.2975 8.20429 15.4732 7.90349 15.6166C7.6485 15.7381 7.37747 15.8284 6.83543 16.0091L4.53855 16.7748M3.22527 15.4615L3.03811 16.023C2.9492 16.2897 3.01862 16.5837 3.21744 16.7826C3.41626 16.9814 3.71035 17.0508 3.97709 16.9619L4.53855 16.7748M3.22527 15.4615L4.53855 16.7748"
                stroke="#131313"
                stroke-width="1.225"
              />
            </svg>
          }
          iconPosition="right"
          iconSize="2"
        />
      </Buttons>
      <OptionsButton>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
          fill="none"
          onClick={() => setIsOptionsOpen(true)}
        >
          <path
            d="M12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7Z"
            fill="white"
          />
          <path
            d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
            fill="white"
          />
          <path
            d="M12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21Z"
            fill="white"
          />
        </svg>
        {isOptionsOpen && (
          <NavOptions ref={optionRef}>
            <NavOption onClick={() => setIsModalOpen(true)}>
              <NavIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M14.6654 9.33197C14.6461 11.608 14.5197 12.8627 13.6923 13.6902C12.7157 14.6667 11.144 14.6667 8.00043 14.6667C4.85692 14.6667 3.28516 14.6667 2.3086 13.6902C1.33203 12.7136 1.33203 11.1418 1.33203 7.99831C1.33203 4.85479 1.33203 3.28303 2.3086 2.30646C3.13602 1.47903 4.39074 1.35267 6.66676 1.33337"
                    stroke="#E8E8E8"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14.6667 4.66671H9.33333C8.1216 4.66671 7.39113 5.26139 7.12027 5.53357C7.0364 5.61786 6.99447 5.66001 6.99387 5.66059C6.99333 5.66116 6.95113 5.7031 6.86687 5.78699C6.59468 6.05785 6 6.78831 6 8.00004V10M14.6667 4.66671L11.3333 1.33337M14.6667 4.66671L11.3333 8.00004"
                    stroke="#E8E8E8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </NavIcon>
              <Typography size="s">Share Video Link</Typography>
            </NavOption>
            <NavOption style={{ marginTop: "0.8rem" }}>
              <NavIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M9.32206 3.56408L9.84106 3.04502C10.7011 2.18502 12.0954 2.18502 12.9554 3.04502C13.8154 3.90502 13.8154 5.29935 12.9554 6.15934L12.4363 6.67839M9.32206 3.56408C9.32206 3.56408 9.3869 4.66707 10.3601 5.64029C11.3334 6.61351 12.4363 6.67839 12.4363 6.67839M9.32206 3.56408L4.55013 8.33598C4.22692 8.65921 4.06532 8.82077 3.92634 8.99896C3.76238 9.20919 3.62183 9.4366 3.50714 9.67724C3.40992 9.88124 3.33765 10.0981 3.19311 10.5317L2.5806 12.3692M12.4363 6.67839L7.66445 11.4503C7.34122 11.7735 7.17966 11.9351 7.00147 12.0741C6.79126 12.2381 6.56382 12.3786 6.32319 12.4933C6.11919 12.5905 5.90237 12.6628 5.46874 12.8073L3.63123 13.4198M2.5806 12.3692L2.43088 12.8184C2.35975 13.0318 2.41529 13.267 2.57434 13.4261C2.7334 13.5851 2.96867 13.6407 3.18206 13.5696L3.63123 13.4198M2.5806 12.3692L3.63123 13.4198"
                    stroke="#E8E8E8"
                    stroke-width="0.980001"
                  />
                </svg>
              </NavIcon>
              <Typography size="s">Customize Page</Typography>
            </NavOption>
          </NavOptions>
        )}
      </OptionsButton>
      <Modal isActive={isModalOpen} closeModal={() => setIsModalOpen(false)}>
        <ShareModal closeModal={() => setIsModalOpen(false)} />
      </Modal>
    </Container>
  );
};

export default Navbar;

const Container = styled.div`
  width: 100%;
  padding: 1.4rem 4rem;
  background-color: #0d0d0d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 769px) {
    padding: 1.2rem 2.4rem;
  }
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 1rem;
  height: 4.2rem;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const OptionsButton = styled.div`
  display: none;
  cursor: pointer;
  width: 2.4rem;
  height: 2.4rem;
  margin: 0.8rem;
  position: relative;
  @media only screen and (max-width: 769px) {
    display: block;
  }
`;

const NavOptions = styled.div`
  position: absolute;
  bottom: -calc(100% + 0.6rem);
  padding: 1.2rem;
  background-color: ${Colors.grey900};
  border-radius: 0.9rem;
  left: -20rem;
  z-index: 2;
`;

const NavOption = styled.div`
  cursor: pointer;
  padding: 1.2rem 1.6rem;
  background: #191919;
  border-radius: 0.4rem;
  width: 17.8rem;
  display: flex;
  align-items: center;
`;

const NavIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.8rem;
`;
